import React from "react";
import { useIntroductionsModel } from "../introductionsModel";
import { SearchTypeEnum, ISearchValue } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useIntroductionsModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "业务名称",
            fieldName: "name",
        }
    ]

    return (
        <YhPageHeader
            title="业务介绍管理"
            justify="end"
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}